import React from "react";
import { useNavigate } from "react-router-dom";
import { Create } from "adminApi/ProductCategoryApi/ProductCategory";
import fields from "../json/ProductCategoryFields.json";
import { validateForm } from "utils/validation";
import { ProductCategoryRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddCategoryForm from "./Componates/AddCategoryForm";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";

const AddCategory = () => {
  const navigate = useNavigate();
  const { formdata } = fields;

  // Initialize form values
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange,setErrors } = useFormChange(initialValues, ProductCategoryRules);

  // Form submit hook
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
      return await Create({data: formData });
    },
    (vals) =>{
     const err =  validateForm(vals, ProductCategoryRules)
     setErrors(err)
     return err;
      },
    () => navigate(-1),
    "Category Created successfully"
  );

  return (
    <>
      {loadingSubmit && <Spinner isSpinner={true} />}
      <AddCategoryForm fields={formdata} values={values} errors={errors} handleChange={handleChange} handleSubmit={(e) => handleSubmit(e, values)} loading={loadingSubmit} title="Add Category" />
    </>
  );
};

export default AddCategory;
